import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, type PropType } from 'vue';

import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { Icons } from '@/font-awesome';
import { DOMUtils } from '@/utils/dom_utils';
import Tooltip from '@/components/Tooltip.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonButton',
  props: {
    icon: {
      type: Object as PropType<IconDefinition>,
      default: null,
    },
    text: {
      type: String,
      default: "",
    },
    action: {
      type: String as PropType<'cta' | 'error' | 'secondary' | 'disabled'>,
      default: "cta",
    },
    type: {
      type: String as PropType<'filled' | 'outlined' | 'text'>,
      default: "filled",
    },
    size: {
      type: String as PropType<'small' | 'medium' | 'large'>,
      default: "medium",
    },
    tooltipText: {
      type: String,
      default: "",
    }
  },
  emits: ["change-page"],
  setup(__props, { expose: __expose }) {

const commonButtonElem = ref<HTMLElement | null>(null);
const quadrant = ref({
  isSuperior: false,
  isLeft: false,
});
const maxHeight = ref(0);

const props = __props;



const cssVars = computed(
  () => {
    return {
      "--btn-border-color": `var(--components-button-color-${props.action}-${props.type}-default-border-color)`,
      "--btn-border-color-hover": `var(--components-button-color-${props.action}-${props.type}-hover-border-color)`,
      "--btn-border-color-active": `var(--components-button-color-${props.action}-${props.type}-active-border-color)`,

      "--btn-background": `var(--components-button-color-${props.action}-${props.type}-default-background-color, #E6E4EB)`,
      "--btn-background-hover": `var(--components-button-color-${props.action}-${props.type}-hover-background-color)`,
      "--btn-background-active": `var(--components-button-color-${props.action}-${props.type}-active-background-color)`,

      "--btn-text-color": `var(--components-button-color-${props.action}-${props.type}-default-text-color)`,
      "--btn-text-color-hover": `var(--components-button-color-${props.action}-${props.type}-hover-text-color)`,
      "--btn-text-color-active": `var(--components-button-color-${props.action}-${props.type}-active-text-color)`,

      "--btn-gap": `calc(var(--components-button-spacing-large-gap) * 1px)`,
      borderRadius: `calc(var(--components-button-border-radius-${props.size}) * 1px)`,

          
      "--btn-padding": `calc(var(--components-button-spacing-${props.size}-padding-vertical) * 1px${props.action !== 'disabled' ? ' - 1px' : ''}) calc(var(--components-button-spacing-${props.size}-padding-horizontal${props.icon ? "-with-icon" : ""}) * 1px)`,
      "--btn-padding-left": props.icon ? `calc(var(--components-button-spacing-${props.size}-padding-horizontal-with-icon) * 1px)` : `calc(var(--components-button-spacing-${props.size}-padding-horizontal) * 1px)`,

      width: props.tooltipText ? '' : '100%',
      height: props.tooltipText ? '' : '100%',
    };
  }
);

onMounted(updateData);
window.addEventListener('resize', updateData);

function updateData() {
  if (!commonButtonElem.value) return;
  quadrant.value = DOMUtils.detectQuadrant(commonButtonElem.value!);
  const margin = 10;
  maxHeight.value = DOMUtils.getDistanceToTopBottom(commonButtonElem.value!) - commonButtonElem.value!.clientHeight - margin;
}

__expose({
  getElement: () => commonButtonElem.value,
});

const showOptions = ref(false);


const __returned__ = { commonButtonElem, quadrant, maxHeight, props, cssVars, updateData, showOptions, get FontAwesomeIcon() { return FontAwesomeIcon }, get Icons() { return Icons }, Tooltip }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})